import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

// eslint-disable-next-line import/prefer-default-export
// export const getOrders = (merchandiserId) => {
//     merchandiserId = merchandiserId ? `?merchandiserId=${merchandiserId}` : "";
//     return axios.get(`${apiUrl}orders/jobs${merchandiserId}`);
// };

export const getOrders = (data) => {
    return axios.post(`${apiUrl}orders/jobs`, data);
};

export const getOrderHeader = (serviceId) => axios.get(`${apiUrl}orders/header?serviceId=${serviceId}`);

export const getOrderDetail = (orderId) => axios.get(`${apiUrl}orders/detail?orderId=${orderId}`);

export const submitOrder = (data) => axios.post(`${apiUrl}orders/submit`, data);

export const unSubmitOrder = (orderId) => axios.post(`${apiUrl}orders/${orderId}/unsubmit`, {});

export const quantityChange = (orderDetailId, serviceId, quantity) =>
    axios.patch(`${apiUrl}orders/detail/quantity?serviceId=${serviceId}&orderDetailId=${orderDetailId}&quantity=${quantity}`);

export const addOrUpdateOrder = (data) => axios.post(`${apiUrl}orders`, data);
